import linkedInIcon from "../img/Icons/LinkedInIcon.png";

export default function LinkedIn(){
    return (
        <div className="linkTile">
            <a href="https://www.linkedin.com/in/milan-rahmie-4959b8265/" target="_blank" rel="noopener noreferrer">
                <img src={linkedInIcon} alt="csharp"/>
            </a>
        </div>
    )
}
